import { makeRequest } from '../../../lib/api';

const RECONCILIATION_PATH = '/v1/reconciliation_acts';
const ORDER_INVOICES_PATH = '/v1/order_invoices';

class vehiclesController {
  // Создать новый Акт взаиморасчётов и привязать к нему указанные счета
  createReconciliationActAndAddInvoices = (data) => {
    return makeRequest('post', `${ RECONCILIATION_PATH }`, data);
  };

  // Возвращает Акт взаиморасчётов по его id
  getReconciliationAct = (id) => {
    return makeRequest('get', `${ RECONCILIATION_PATH }/${ id }`);
  };

  // Возвращает список счетов в акте взаиморасчёта по его id
  getReconciliationActContent = (id) => {
    return makeRequest('get', `${ RECONCILIATION_PATH }/${ id }/invoices`);
  };

  // Найти Акты взаиморасчётов согласно переданному в запросе фильтру
  getReconciliationActList = (data) => {
    return makeRequest('post', `${ RECONCILIATION_PATH }/find`, data);
  };

  // Привязать указанные счета к заданному существующему Акту взаиморасчётов
  addInvoicesToReconciliationAct = (data) => {
    return makeRequest('put', `${ RECONCILIATION_PATH }/${ data?.reconciliationActId }`, {
      invoiceIds: data.invoiceIds,
    });
  };

  // Отвязать указанные счета от заданного существующего Акта взаиморасчётов
  deleteInvoiceFromReconciliationAct = (data) => {
    return makeRequest('delete', `${ RECONCILIATION_PATH }/${ data?.reconciliationActId }`, {
      invoiceIds: data.invoiceIds,
    });
  };

  // Пересчитать комиссии по счёту
  recalculateInvoice = (id) => {
    return makeRequest('put', `${ ORDER_INVOICES_PATH }/${ id }/fee_rate`);
  };

  // Уведомить о пересчёте комиссий по акту
  recalculateRecalculationNotify = (id) => {
    return makeRequest('post', `${ RECONCILIATION_PATH }/${ id }/notify/recalculation`);
  };

  // Найти Акты взаиморасчётов согласно переданному в запросе фильтру
  getReconciliationActCommentHistory = (id) => {
    return makeRequest('get', `${ RECONCILIATION_PATH }/${ id }/comments`);
  };

  // Блок управления состоянием счёта
  // Принять указанный Акт, т.е. перевести его из состояния 'Акт сформирован' в состояние 'Акт согласован'
  reconciliationRatify = (id) => {
    return makeRequest('put', `${ RECONCILIATION_PATH }/${ id }/ratify`);
  };

  // Отклонить указанный Акт, т.е. перевести его из состояния 'Акт сформирован' или 'Акт согласован' в состояние 'Акт отклонён'
  reconciliationReject = (data) => {
    return makeRequest('put', `${ RECONCILIATION_PATH }/${ data.id }/reject`, { comment: data.comment });
  };

  // Отправить на проверку указанный Акт, т.е. перевести его из состояния 'Акт отклонён' в состояние 'Акт сформирован'
  reconciliationVerify = (id) => {
    return makeRequest('put', `${ RECONCILIATION_PATH }/${ id }/verify`);
  };

  // Акт оплачен
  reconciliationFinalize = (id) => {
    return makeRequest('put', `${ RECONCILIATION_PATH }/${ id }/finalize`);
  };
  // Конец блока управления состоянием счёта

  // Полностью удалить указанный Акт и историю комментариев к нему, также отвязав от него счета
  reconciliationHardDelete = (id) => {
    return makeRequest('delete', `${ RECONCILIATION_PATH }/${ id }/hard`);
  };
}

export default new vehiclesController();
